import { Delta } from 'jsondiffpatch/lib/types';

export enum ChangeHistoryKey {
  log = 'log',
  oldData = 'oldData',
  newData = 'newData',
}

export interface ChangeHistory {
  [ChangeHistoryKey.log]: Delta;
  [ChangeHistoryKey.oldData]?: any;
  [ChangeHistoryKey.newData]?: any;
}
